var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('video',{ref:"video",staticClass:"video",class:_vm.facingModeInternal,attrs:{"autoplay":"","playsinline":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }